module.exports = __webpack_public_path__ + "static/addicting-as-social-media-4391464bb7480ef0311a57d70b9bb515.webp";